import React from "react";
import Layout from "./Components/Layout";
import NewsItem from "./Components/NewsItem";
import styles from "./styles/Home.module.css";
import { news } from "./data/Chinese-Zodiac-Horoscope";

export default function Home() {
  const slicedNews = Array.isArray(news) ? news.slice(0, 12) : [];

  return (
    <div className={styles.container}>
      <Layout
        imageUrl="https://mychinesehoroscope.com/my-chinese-horoscope-finder.png"
      >
        {/* ✅ CLEAN HERO – NO SEARCH */}
        <section id="home" className={styles.home}>
          <h1 className={styles.title}>My Chinese Horoscope</h1>
<h2>Your Chinese Horoscope Zodiac Finder</h2>
          <p className={styles.paragraph}>
            Discover your <b>Chinese Zodiac sign</b> and uncover insights about
            your personality, destiny, and life path based on ancient Chinese
            astrology.  
          </p>
        </section>

        {/* CONTENT SECTION */}
        <section className={styles.containerbox}>
          <h2 className={styles.title}>Explore the Twelve Chinese Zodiac</h2>

          <p className={styles.description}>
            Each Chinese zodiac sign carries unique meanings, strengths, and
            destiny patterns. Explore the ancient wisdom behind all twelve signs
            and see how the stars align for you.
          </p>

          <div className={styles.homenews}>
            {slicedNews.length === 0 && <h3>No Zodiac Articles</h3>}
            {slicedNews.map((item) => (
              <NewsItem key={item.id} news={item} />
            ))}
          </div>
        </section>
      </Layout>
    </div>
  );
}
